<template>
  <div class="page-container my-card-registration-page full-width">
    <div class="no-cards-info" v-show="!hasCards">
      {{ $t('cards.noCardsAvailable') }}
    </div>

    <div class="register-new-card" v-show="hasCards">
      {{ $t('cards.buttons.registerNewCard') }}
    </div>

    <card-registration/>
    <button type="button" class="btn-buy button btn-with-icon" @click="this.$router.push({ name: 'buy-card' })">{{ $t('buyCard') }} <img class="button-icon-no-hover" src="@/assets/svgs/2024/icons/arrow-big-white.svg"><img class="button-icon-hover" src="@/assets/svgs/2024/icons/arrow-big.svg"></button>
  </div>
</template>

<script>
export default {
  name: 'MyCardPage',
  components: {
    CardRegistration: () => import('@/components/CardRegistration.vue'),
  },
  data() {
    return {}
  },
  computed: {
    hasCards() {
      return this.$store.state.cards.length >= 1
    }
  }
}
</script>

<style lang="scss">
.page-container.my-card-registration-page {
  padding: 3rem 0;
  position: relative;
  /*z-index: 1000;*/
  max-width: 100vw !important;

  .no-cards-info,
  .register-new-card {
    margin-bottom: 3rem;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .btn-buy {
    width: 316px;
    background-color: $dark-gray;
    color: $white;
    margin: 2rem auto 0 auto;

    &:hover {
      color: $dark-gray;
      background: $white;
      border-color: $dark-gray;
    }
  }
}
</style>
